import './Home.css'

const More = () => {
  return (
    <div className="home">
      <section className="hero">
        <div className="container">
          <h1>More Information</h1>
          <p className="hero-subtitle">
            Additional resources and information
          </p>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <h3>Documentation</h3>
              <p>Comprehensive guides and documentation to help you get started with our platform.</p>
            </div>
            <div className="feature-card">
              <h3>Support</h3>
              <p>Need help? Our support team is here to assist you with any questions or issues.</p>
            </div>
            <div className="feature-card">
              <h3>Contact Us</h3>
              <p>Get in touch with us for business inquiries, partnerships, or general questions.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default More





